// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 691 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"691":"89cec1ba94bf80bc2402","731":"107fbb527587c40b793a","843":"30a9b1dd6d2ef35b4593"}[chunkId] + ".js";
};